import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { ModalFormBody } from './Modal';
import { BasePage } from '../BasePage';
import { ErrorPage } from '../ErrorPage';
import { ErrorPageFallback } from '../error-boundary-utils';
import type { LogArgument } from '../../../utils/logger';
import { ExpectedError } from '../../../utils/errors';
import { usePartialConfigOnClose } from './partialConfigModalUtils';
import { PartialConfigModalFooter } from './PartialConfigModalFooter';

export function CloseButton({ onClose }: { onClose: () => void }) {
    return (
        <button onClick={onClose} type="button" aria-label="Close">
            <FontAwesomeIcon icon={faTimes} className="h-6 w-6" />
        </button>
    );
}

function PartialConfigNotFoundFallback() {
    const onClose = usePartialConfigOnClose();
    const title = gettext('PARTIAL_CONFIG_NOT_FOUND');

    return (
        <>
            <ModalFormBody>
                <BasePage
                    title={title}
                    besideTitle={<CloseButton onClose={onClose} />}
                    wrapMainContainer={false}
                    forModalUsage={true}
                >
                    <div className="flex min-h-[200px] items-center justify-center text-sm text-gray-600">
                        {title}
                    </div>
                </BasePage>
            </ModalFormBody>
            <PartialConfigModalFooter />
        </>
    );
}

export class PartialConfigNotFoundError extends ExpectedError {
    FallbackElement = PartialConfigNotFoundFallback;
}

function ModalErrorPage({
    error,
    resetBoundary,
}: {
    error?: LogArgument;
    resetBoundary?: () => void;
}) {
    return (
        <>
            <ModalFormBody>
                <ErrorPage
                    tryAgain={resetBoundary}
                    error={error}
                    wrapMainContainer={false}
                    forModalUsage={true}
                />
            </ModalFormBody>
            <PartialConfigModalFooter />
        </>
    );
}

// Wrap the default error fallback with modal-specific layout and footer.
export function PartialConfigErrorFallback({ error }: { error: LogArgument }) {
    return <ErrorPageFallback error={error} ErrorPageComponent={ModalErrorPage} />;
}
